import * as React from 'react';
import { useLazyQuery } from '@grandvisionhq/graphql';
import { RECOVERABLE_ERROR, CANNOT_EXECUTE_QUERY } from '../../../../../types/generic-query-errors.js';
import '../../../../../types/product.js';
import '../../operations/queries/get-cart-discounts-by-promotion-identifier.js';
import { GET_CONTACT_LENS_BY_PRESCRIPTION } from '../../operations/queries/get-contact-lens-by-prescription.js';
import '../../types/quantity-discounts.js';
import { mapServerToClientPrescriptionCLProduct } from './mappers/server-to-client/map-to-client-prescription-contact-lens-product.js';

const useGetCLByPrescription = ({ onSuccess , onError  })=>{
    const [query] = useLazyQuery(GET_CONTACT_LENS_BY_PRESCRIPTION, {
        fetchPolicy: 'no-cache',
        onCompleted (result) {
            const mappedResult = mapServerToClientPrescriptionCLProduct(result);
            if (mappedResult.type === 'SUCCESS') {
                onSuccess(mappedResult);
            } else {
                onError === null || onError === void 0 ? void 0 : onError({
                    error: mappedResult.error
                });
            }
        },
        onError () {
            onError === null || onError === void 0 ? void 0 : onError({
                error: RECOVERABLE_ERROR
            });
        }
    });
    const getCLByPrescription = React.useCallback((variables, activeSku)=>{
        if (variables.masterVariantSku === '') {
            console.error(`Cannot call getCLByPrescription for Contact Lens product with sku: ${activeSku} because the masterVariantSku is invalid.`);
            return onError === null || onError === void 0 ? void 0 : onError({
                error: CANNOT_EXECUTE_QUERY
            });
        } else {
            query({
                variables
            });
        }
    }, [
        query
    ]);
    return React.useMemo(()=>getCLByPrescription
    , [
        getCLByPrescription
    ]);
};

export { useGetCLByPrescription };
//# sourceMappingURL=use-get-cl-by-prescription.js.map
